/**
 * A cold-load skeleton block (Story 4.1, UX state patterns). Reserves layout
 * height so the dashboard doesn't jump when data arrives. Decorative — hidden from
 * the accessibility tree; the surrounding region carries the loading semantics.
 */
export function Skeleton({
  height = 16,
  width = '100%',
  radius = 'var(--rounded-md)',
}: {
  height?: number | string;
  width?: number | string;
  radius?: string;
}): React.JSX.Element {
  return (
    <div
      className="skeleton"
      aria-hidden="true"
      style={{ height, width, borderRadius: radius }}
    />
  );
}
